import ScrollToTop from "@/hooks/scroll-to-top";
import { animationCreate } from "@/utils/utils";
import React, { useEffect, useState } from "react";

const Wrapper = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // Una vez que el componente se monta en el cliente, actualizamos el estado.
    setIsMounted(true);
  }, []);

  useEffect(() => {
    // Solo ejecutamos las animaciones si el componente está montado en el cliente.
    if (isMounted) {
      setTimeout(() => {
        animationCreate();
      }, 500);
    }
  }, [isMounted]);

  return (
    <>
      {children}
      <ScrollToTop />
    </>
  );
};

export default Wrapper;